import { Component, Input, OnInit } from '@angular/core';
import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';

@Component({
  selector: 'app-layout-master',
  templateUrl: './layout-master.component.html',
  styleUrls: ['./layout-master.component.scss']
})
export class LayoutMasterComponent implements OnInit {

  @Input() environment: any;
  isLoadingPanel: boolean = false;

  constructor(private msalAuthService: MsalService, public auth: AuthenticationService) { }

  ngOnInit(): void {
    this.auth.isLoading.subscribe((data) => {
      this.isLoadingPanel = data;
    });
  }

}
